// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".progress-parent-div{width:395px}", "",{"version":3,"sources":["webpack://./../../components/account-subscriptions/billing-v2/transaction-account/src/sidebar-panels/create-invoice-group-sidebar.scss"],"names":[],"mappings":"AAAA,qBACE,WAAA","sourcesContent":[".progress-parent-div {\n  width: 395px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
